export const TaskChatInavctive = ({ size = "16" }: { size?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      d="M8 4.66667V0.306667C8.6167 0.539557 9.17686 0.900874 9.64333 1.36667L11.966 3.69067C12.4323 4.15659 12.7939 4.7166 13.0267 5.33333H8.66667C8.48986 5.33333 8.32029 5.2631 8.19526 5.13807C8.07024 5.01305 8 4.84348 8 4.66667ZM13.3333 6.99V12.6667C13.3323 13.5504 12.9807 14.3976 12.3559 15.0225C11.731 15.6474 10.8837 15.9989 10 16H3.33333C2.4496 15.9989 1.60237 15.6474 0.97748 15.0225C0.352588 14.3976 0.00105857 13.5504 0 12.6667V3.33333C0.00105857 2.4496 0.352588 1.60237 0.97748 0.97748C1.60237 0.352588 2.4496 0.00105857 3.33333 0L6.34333 0C6.452 0 6.55933 0.00866667 6.66667 0.016V4.66667C6.66667 5.1971 6.87738 5.70581 7.25245 6.08088C7.62753 6.45595 8.13623 6.66667 8.66667 6.66667H13.3173C13.3247 6.774 13.3333 6.88133 13.3333 6.99ZM8 12.6667C8 12.4899 7.92976 12.3203 7.80474 12.1953C7.67971 12.0702 7.51014 12 7.33333 12H4C3.82319 12 3.65362 12.0702 3.5286 12.1953C3.40357 12.3203 3.33333 12.4899 3.33333 12.6667C3.33333 12.8435 3.40357 13.013 3.5286 13.1381C3.65362 13.2631 3.82319 13.3333 4 13.3333H7.33333C7.51014 13.3333 7.67971 13.2631 7.80474 13.1381C7.92976 13.013 8 12.8435 8 12.6667ZM10 10C10 9.82319 9.92976 9.65362 9.80474 9.5286C9.67972 9.40357 9.51015 9.33333 9.33333 9.33333H4C3.82319 9.33333 3.65362 9.40357 3.5286 9.5286C3.40357 9.65362 3.33333 9.82319 3.33333 10C3.33333 10.1768 3.40357 10.3464 3.5286 10.4714C3.65362 10.5964 3.82319 10.6667 4 10.6667H9.33333C9.51015 10.6667 9.67972 10.5964 9.80474 10.4714C9.92976 10.3464 10 10.1768 10 10Z"
      fill="url(#paint0_linear_3734_7755)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3734_7755"
        x1="6.66667"
        y1="0"
        x2="6.66667"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C0BBCF" />
        <stop offset="1" stopColor="#968FA9" />
      </linearGradient>
    </defs>
  </svg>
);
